<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="接班人员" prop="manager">
              <j-dict-select-tag
                :dictCode="
                  `sys_user,realname,id,del_flag='0' and executor_maintain = 1 and rel_tenant_ids='${this.$ls.get(
                    'TENANT_ID'
                  )}' order by realname`
                "
                placeholder="请选择接班人员"
                type="list"
                v-model="model.manager"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="接班确认" prop="confirmation">
              <j-image-upload isMultiple v-model="model.confirmation"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="  " prop="clear" :colon="false">
              <a-checkbox v-model="model.clear" default-checked>{{ config.clear.name }}</a-checkbox>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="  " prop="handover" :colon="false">
              <a-checkbox v-model="model.handover" default-checked>{{ config.handover.name }}</a-checkbox>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="备注" prop="remark">
              <a-textarea isMultiple v-model="model.remark" rows="6"></a-textarea>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <div v-if="autoOn">
      <a-steps @change="onStepChange" size="small" type="navigation" v-model="currentStep">
        <a-step :status="allowed[0] ? 'finish' : 'error'" description="是否开启自动运行." title="重要设备" />
        <a-step :status="allowed[1] ? 'finish' : 'error'" description="是否处于健康范围." title="关键指标" />
        <a-step :status="allowed[2] ? 'finish' : 'error'" description="是否影响正常运行." title="告警确认" />
        <a-step :status="allowed[3] ? 'finish' : 'error'" description="是否影响正常运行." title="缺陷确认" />
      </a-steps>
      <a-carousel ref="stepContent">
        <div>
          <div class="check-wrapper">
            <a-checkbox :disabled="formDisabled || autoDevDisabled" @change="checkChange($event, 0)"
              >满足自动运行条件</a-checkbox
            >
          </div>
          <a-alert
            description="如果设备未开启自动模式，系统可能无法安全地自动运行."
            message="警告"
            show-icon
            style="margin-bottom: 10px;"
            type="warning"
          />

          <a-descriptions :column="2" bordered>
            <a-descriptions-item :key="`dev-${item.pointCode}`" v-for="item of autoDevs">
              <template slot="label">
                <span>{{ item.pointCode_dictText }}</span>
                <a-tag color="orange" style="margin-left: 10px;" v-if="item.isForce === 'Y'">强制</a-tag>
              </template>
              <a-tag :color="item.isAllowed ? 'green' : 'red'">{{ item.msg }}</a-tag>
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div>
          <div class="check-wrapper">
            <a-checkbox :disabled="formDisabled || autoPointValDisabled" @change="checkChange($event, 1)"
              >满足自动运行条件</a-checkbox
            >
          </div>
          <a-alert
            description="如果指标不处于可靠区间内，系统可能无法安全地自动运行."
            message="警告"
            show-icon
            style="margin-bottom: 10px;"
            type="warning"
          />
          <a-descriptions bordered>
            <a-descriptions-item :key="`point-${item.pointCode}`" v-for="item of pointVals">
              <template slot="label">
                <span>{{ item.pointCode_dictText }}</span>
                <a-tag color="orange" style="margin-left: 10px;" v-if="item.isForce === 'Y'">强制</a-tag>
                <br />
                <span style="font-size: 10px; font-weight: 300; font-style: italic;">{{
                  `(${item.standardBottom || '无限制'} ~ ${item.standardTop || '无限制'})`
                }}</span>
              </template>
              <a-tag :color="item.isAllowed ? 'green' : 'red'">{{ item.snapshot }}</a-tag>
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div>
          <div class="check-wrapper">
            <a-checkbox :disabled="formDisabled" @change="checkChange($event, 2)">满足自动运行条件</a-checkbox>
          </div>
          <a-alert
            description="如果存在未完结缺陷，系统可能无法安全地自动运行."
            message="警告"
            show-icon
            style="margin-bottom: 10px;"
            type="warning"
          />
          <grid-table
            :columns="alertListColumns"
            :queryParams="{ isRecovery: 0 }"
            :url="this.url.alertList"
            ref="alertTable"
          >
            <span slot="levelSlot" slot-scope="text, record">
              <a-tag :color="$filterDictTextByCache('alert_level_color', text)">{{ record.alertLevel_dictText }}</a-tag>
            </span>
          </grid-table>
        </div>
        <div>
          <div class="check-wrapper">
            <a-checkbox :disabled="formDisabled" @change="checkChange($event, 3)">满足自动运行条件</a-checkbox>
          </div>
          <a-alert
            description="如果存在未恢复告警事件，系统可能无法安全地自动运行"
            message="警告"
            show-icon
            style="margin-bottom: 10px;"
            type="warning"
          />
          <grid-table
            :columns="defectListColumns"
            :queryParams="{ defStatusStr: '0, 1, 2' }"
            :url="this.url.defectList"
            ref="defectTable"
          >
            <span slot="defLevel" slot-scope="priority, record">
              <a-tag :color="$filterDictTextByCache('def_level_color', record.defLevel)">{{
                record.defLevel_dictText
              }}</a-tag>
            </span>
          </grid-table>
        </div>
      </a-carousel>
    </div>

    <account-detect-modal @ok="save" ref="accoutDetectModal"></account-detect-modal>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import GridTable from '@/views/workbench/components/Itable.vue'
import moment from 'dayjs'

import AccountDetectModal from './AccountDetectModal'

export default {
  name: 'YwDutyRecordForm',
  components: {
    GridTable,
    AccountDetectModal
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    const forceNowrap = text => <span class="j-force-nowrap">{text}</span>
    return {
      ifAutoRun: false,
      currentStep: 0,
      model: {
        handover: true,
        clear: true
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      config: {
        handover: {
          name: '两交接（现场交接、实物交接）'
        },
        clear: {
          name: '五清（看清、讲清、问清、查清、点清）'
        }
      },
      confirmLoading: false,
      validatorRules: {
        manager: [{ required: true, message: '请选择接班值长!' }]
      },
      url: {
        add: '/duty/dutyRecord/add',
        edit: '/duty/dutyRecord/edit',
        queryById: '/duty/dutyRecord/queryById',
        alertList: '/alert/iotAlert/list',
        defectList: '/device/defRegister/list',
        autoPointSnapShot: '/event/autoDevConfig/snapshot',
        importantPointSnapshot: '/event/autoPointValConfig/snapshot',

        querySewegeAutoConf: '/device/sewegePlantAutoConfig/list',
        editSewegeAutoStatus: '/device/sewegePlantAutoConfig/edit',

        getCategoryList: '/custom/category/childListByPCode'
      },
      sewegeAutoConf: {},
      autoOn: false,
      allowed: [false, false, false, false],
      autoDevs: [],
      pointVals: [],
      alertListColumns: [
        {
          title: '告警描述',
          align: 'center',
          dataIndex: 'summary',
          width: '50%',
          align: 'left'
        },
        {
          title: '告警时间',
          align: 'center',
          dataIndex: 'alertTime',
          customRender: forceNowrap
        },
        {
          title: '告警级别',
          align: 'center',
          dataIndex: 'alertLevel_dictText',
          scopedSlots: { customRender: 'levelSlot' }
        },
        {
          title: '告警来源',
          align: 'center',
          dataIndex: 'alertType_dictText',
          customRender: forceNowrap
        }
      ],
      defectListColumns: [
        {
          title: '设备名称',
          align: 'center',
          dataIndex: 'devName'
        },
        {
          title: '缺陷内容',
          align: 'center',
          dataIndex: 'defContent'
        },
        {
          title: '缺陷等级',
          align: 'center',
          dataIndex: 'defLevel',
          scopedSlots: { customRender: 'defLevel' }
        },
        {
          title: '缺陷发现时间',
          align: 'center',
          dataIndex: 'defFindTime',
          width: 180
        }
      ]
    }
  },
  computed: {
    formDisabled() {
      return this.disabled
    },
    autoDevDisabled() {
      let disabled = false
      for (const item of this.autoDevs) {
        if (item.isForce === 'Y' && !item.isAllowed) {
          disabled = true
          continue
        }
      }
      return disabled
    },
    autoPointValDisabled() {
      let disabled = false
      for (const item of this.pointVals) {
        if (item.isForce === 'Y' && !item.isAllowed) {
          disabled = true
          continue
        }
      }
      return disabled
    }
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))

    this.initSewegeConf()

    this.getFormPropsConfig()
  },
  methods: {
    getFormPropsConfig() {
      const that = this
      getAction(this.url.getCategoryList, {
        pCode: 'A14A01'
      }).then(res => {
        if (res.success) {
          res.result.forEach(prop => {
            if (prop.name === 'handover') {
              that.config.handover.name = prop.cusProp1
            } else if (prop.name === 'clear') {
              that.clear.handover.name = prop.cusProp1
            }
          })
        } else {
          this.$message.warning('公共编码配置不正确，请联系管理员')
        }
      })
    },
    initSewegeConf() {
      getAction(this.url.querySewegeAutoConf, {}).then(res => {
        if (res.success) {
          this.autoOn = res.result.records[0]?.autoOn === 'Y'
          this.sewegeAutoConf = res.result.records[0]
        } else {
          this.$message.error(res.message)
        }
        this.initAutoRunCheck()
        this.getAutoDevSnapShot()
        this.getAutoPointSnapShot()
      })
    },
    initAutoRunCheck() {
      const now = moment().hour()
      this.autoOn = this.autoOn && (now >= this.sewegeAutoConf.autoHourStart || now < this.sewegeAutoConf.autoHourEnd)
    },
    checkChange(event, index) {
      this.allowed[index] = event.target.checked
    },
    getAutoDevSnapShot() {
      getAction(this.url.autoPointSnapShot).then(res => {
        if (res.success) {
          if (res.result.records) {
            res.result.records.forEach(point => {
              const condition = JSON.parse(point.autoCondition)
              for (let index = 0; index < condition.length; index++) {
                const item = condition[index]
                if (item.value === point.snapshot) {
                  point.msg = item.msg
                  if (index === 0) {
                    point.isAllowed = true
                  } else {
                    point.isAllowed = false
                  }
                }
              }
            })
          }
          this.autoDevs = res.result.records
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    getAutoPointSnapShot() {
      getAction(this.url.importantPointSnapshot).then(res => {
        if (res.success) {
          if (res.result.records) {
            res.result.records.forEach(point => {
              const value = point.snapshot
              if (eval(point.expression)) {
                point.isAllowed = true
              } else {
                point.isAllowed = false
              }
            })
          }
          this.pointVals = res.result.records
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    onStepChange(current) {
      this.currentStep = current
      this.$refs['stepContent'].goTo(current, false)
    },
    add() {
      this.edit(this.modelDefault)
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    save() {
      this.confirmLoading = true
      let httpurl = ''
      let method = ''
      if (!this.model.id) {
        httpurl += this.url.add
        method = 'post'
      } else {
        httpurl += this.url.edit
        method = 'put'
      }
      httpAction(httpurl, this.model, method)
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.editSewegeAutoStatus()
            this.$emit('ok')
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    editSewegeAutoStatus() {
      this.sewegeAutoConf.autoStatus = this.autoOn ? 'Y' : 'N'
      httpAction(this.url.editSewegeAutoStatus, this.sewegeAutoConf, 'put')
    },
    validateAll() {
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          this.initAutoRunCheck()
          if (this.autoOn) {
            let totalAllowed = this.allowed.reduce((acc, cur) => {
              return acc + (cur - 0)
            }, 0)

            if (totalAllowed < this.allowed.length) {
              this.$message.warning('请先确认是否满足自动运行条件')
              return false
            }
          }
          this.$refs.accoutDetectModal.show(this.model.manager, '接班值长确认')
        }
      })
    }
  }
}
</script>
<style>

.check-wrapper {
  margin: 20px;
  text-align: center;
}

</style>
